import React from 'react';

// Local Components
import CustomAccordion from '../Filtering/CustomAccordion';

// Typography
import { Body2 } from '../../themes/typography';

const accordionDetails = [
    {
        title: 'Event Organizer',
        content:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident aliquam asperiores porro dignissimos neque sequi reiciendis, rem ipsam itaque fugit eos commodi illum corrupti atque quaerat aliquid molestias similique in officia non ex? Accusamus earum nam vitae amet officia cum itaque facere placeat blanditiis velit, in nisi, quas, quod quibusdam.'
    },
    {
        title: 'Shmooz',
        content:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident aliquam asperiores porro dignissimos neque sequi reiciendis, rem ipsam itaque fugit eos commodi illum corrupti atque quaerat aliquid molestias similique in officia non ex? Accusamus earum nam vitae amet officia cum itaque facere placeat blanditiis velit, in nisi, quas, quod quibusdam.'
    }
];

export default function TermsAndConditon({ name = 'Terms & Conditions' }) {
    return (
        <CustomAccordion accordtionTitle={name} darkMode>
            <div className="event-and-platform-terms-condition">
                {/* Event Terms & Conditions */}
                {accordionDetails.map((item, index) => (
                    <CustomAccordion
                        accordtionTitle={<Body2>{item.title}</Body2>}
                        key={index}
                        darkMode
                    >
                        <Body2>{item.content}</Body2>
                    </CustomAccordion>
                ))}
            </div>
        </CustomAccordion>
    );
}
